import React, { useEffect, useRef } from "react";
import { connect, ConnectedProps } from "react-redux";

import { tileType } from "../../../../lib/enums";
import { openDialog, openTooltip } from "../../../../store/actions";

import SlotPerson from "./SlotPerson";
import SlotPersonEmpty from "./SlotPersonEmpty";
import { setSameHeight } from "../../../../lib/elementUtilities";
import { SlotType } from "../../../../lib/types";

interface IProps {
  tile: any;
}

const mapStateToProps = (state: any) => ({
  resources: state.governorate.resources,
  tiles: state.governorate.tiles,
  tilePrices: state.governorate.tilePrices,
  slotPrices: state.governorate.slotPrices,
  allBuildings: state.governorate.allBuildings,
  freePops: state.governorate.population.free
})

const mapDispatchToProps = (dispatch: any) => ({
  openDialog: (dialogOptions: any) => dispatch(openDialog(dialogOptions)),
  openTooltip: (tooltipOptions: any) => dispatch(openTooltip(tooltipOptions))
});

const connector = connect(mapStateToProps, mapDispatchToProps);

const TileDiv = (props: IProps & ConnectedProps<typeof connector>) => {
  const tileRef = useRef(null);

  useEffect(() => {
    setTimeout(() => setSameHeight(tileRef.current || undefined), 750);
  }, []);

  return (
    <>
      <div className="box">
        <div className={"text-left"}>
          <h2 className="h2" style={{ textAlign: "left" }}>
            <span>{props.tile.name} ({props.tile.shortName})</span>&nbsp;
            <a href="#" className="no-text-decoration" onClick={event => props.openDialog({
              name: "NewBuilding",
              availableBuildings: props.tile.availableBuildings,
              tileBuildings: props.allBuildings
                .filter((b: SlotType) => !!b.id && b.level === 1),
              tileTypeId: props.tile.typeId,
              possible: true,
              classes: ["new-manor"],
              slotPrices: props.slotPrices,
              event
            })}>
              <i className="icon icon-xs icon-plus middle" />
            </a>
          </h2>
        </div>
        <div ref={tileRef} className={`row tile ${props.tile.typeId === tileType.CITY ? "town" : "village"}`}>
          {/* <div className="col-md-8 col-sm-12"> */}
          {/* {Object.values(props.tile.slots).map((slot: any) => <Slot */}
          {/*  key={slot.id} */}
          {/*  tileTypeId={props.tile.typeId} */}
          {/*  slot={slot} */}
          {/*  clicked={(elementRef: any) => (slot.turnsToBuilt || slot.type.id */}
          {/*    ? props.openTooltip({ */}
          {/*      name: "BuildingInfo", */}
          {/*      dynamic: true, */}
          {/*      classes: ["full-width"], */}
          {/*      slot, */}
          {/*      tileTypeId: props.tile.typeId, */}
          {/*      closeControl: true, */}
          {/*      elementRef */}
          {/*    }) */}
          {/*    : props.openDialog({ */}
          {/*      slotId: slot.id, */}
          {/*      name: "NewBuilding", */}
          {/*      availableBuildings: props.tile.availableBuildings, */}
          {/*      possible: false, */}
          {/*      classes: ["new-manor"], */}
          {/*      slotPrices: props.slotPrices, */}
          {/*      elementRef: elementRef.current */}
          {/*    })) */}
          {/*  } */}
          {/* />) */}
          {/* } */}
          {Object.values(props.tile.slots).map((slot: any) => <SlotPerson
            key={slot.id}
            tile={props.tile}
            slotPrices={props.slotPrices}
            allBuildings={props.allBuildings}
            slot={slot}
            freePops={props.freePops}
          />)}
          {Object.keys(props.tile.slots).length < 6
            ? <>
              <SlotPersonEmpty
                tileTypeId={props.tile.typeId}
                buttonText={"Buy slot"}
                clickAction={ref => props.openDialog({
                  name: "ExpandTile",
                  tileId: props.tile.id,
                  tileTypeName: props.tile.type.name,
                  price: props.tile.upgradePrice,
                  elementRef: ref?.current
                })}
              />
              {
                Array(6 - Object.keys(props.tile.slots).length - 1).fill(0)
                  .map((e, index) => <SlotPersonEmpty
                    key={index}
                    tileTypeId={props.tile.typeId}
                    icon={"zamek"}
                    disabled={true}
                  />)
              }
            </> : <></>
          }
          {/* </div> */}
        </div>
      </div>
    </>
  )
}

export default connector(TileDiv);
